module.exports = __webpack_public_path__ + "img/plane_track_1.14330436.svg";